import React, { useEffect, useState, Children } from 'react';
import { ChevronDown, Phone } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { motion, useAnimation, AnimatePresence } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
export function FAQ() {
  const {
    t
  } = useLanguage();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const controls = useAnimation();
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  useEffect(() => {
    if (inView) {
      controls.start('visible');
    }
  }, [controls, inView]);
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.4,
        ease: 'easeOut'
      }
    }
  };
  return <section className="py-24 bg-gray-50" data-id="element-15">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16">
        <div className="text-center mb-16" data-id="element-17">
          <h2 className="text-3xl md:text-4xl font-heading font-extrabold text-brand-black mb-3" data-id="element-18">
            {t.faq.title}
          </h2>
          <p className="text-lg text-gray-600 font-medium mb-4" data-id="element-19">
            {t.faq.subtitle}
          </p>
          <div className="w-24 h-1.5 bg-brand-red mx-auto rounded-full" data-id="element-20"></div>
        </div>

        <motion.div ref={ref} variants={containerVariants} initial="hidden" animate={controls} className="space-y-4" data-id="element-21">
          {t.faq.items.map((item, index) => <motion.div key={index} variants={itemVariants} className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden" data-id="element-22">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors" data-id="element-23">
                <span className="text-lg font-heading font-bold text-brand-black pr-4" data-id="element-24">
                  {item.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-blue flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-25" />
              </button>
              <AnimatePresence data-id="element-26">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-27">
                    <div className="px-6 pb-6 text-gray-600 leading-relaxed border-t border-gray-100 pt-4" data-id="element-28">
                      {item.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </motion.div>

        <div className="mt-12 text-center" data-id="element-29">
          <p className="text-gray-600 mb-4 font-medium" data-id="element-30">
            {t.faq.items[0].q.includes('How') ? 'Still have questions?' : '¿Aún tiene preguntas?'}
          </p>
          <a href="tel:8324397965" className="inline-flex items-center justify-center gap-2 bg-brand-red text-white px-8 py-4 rounded-md font-bold text-lg hover:bg-red-800 transition-all shadow-lg hover:-translate-y-0.5 min-h-[56px]" data-id="element-31">
            <Phone className="w-5 h-5" data-id="element-32" />
            (832) 439-7965
          </a>
        </div>
      </div>
    </section>;
}